var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0099 10C10.607 10 10.2053 9.8819 9.86929 9.6457L7.16836 7.71336C6.97385 7.57442 6.94374 7.32165 7.09971 7.14958C7.25689 6.97804 7.54113 6.95079 7.73504 7.0892L10.4336 9.0194C10.7726 9.25774 11.2502 9.25774 11.5916 9.01726L14.263 7.09027C14.4569 6.94972 14.7412 6.97644 14.899 7.14851C15.0562 7.32005 15.0266 7.57228 14.8333 7.71229L12.1571 9.6425C11.8187 9.88083 11.414 10 11.0099 10Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_618_1304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H21.4999V19.5H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_618_1304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3516 13.779H13.1474C13.1484 13.778 13.1523 13.779 13.1552 13.779C13.7125 13.779 14.2067 13.5797 14.5857 13.2012C15.0257 12.7632 15.2674 12.1337 15.2674 11.4289V8.07479C15.2674 6.71077 14.3757 5.72084 13.1474 5.72084H8.35258C7.12433 5.72084 6.23256 6.71077 6.23256 8.07479V11.4289C6.23256 12.1337 6.47479 12.7632 6.91433 13.2012C7.2933 13.5797 7.78802 13.779 8.34477 13.779H8.3516ZM8.3433 14.5115C7.58974 14.5115 6.91677 14.238 6.39714 13.7204C5.81842 13.1431 5.5 12.3295 5.5 11.4289V8.07479C5.5 6.31519 6.7263 4.98828 8.35258 4.98828H13.1474C14.7737 4.98828 16 6.31519 16 8.07479V11.4289C16 12.3295 15.6816 13.1431 15.1029 13.7204C14.5837 14.2376 13.9103 14.5115 13.1552 14.5115H13.1474H8.35258H8.3433Z",
    fill: "#333333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.12f74ac55889939738bb723392bed516.svg";
export { ForwardRef as ReactComponent };